__turbopack_context__.v({
  "className": "caveat_f62b07b3-module__Bviggq__className",
});
